import { useEffect } from 'react';

import { StatRow } from './stat-row';
import { StatsPeriodFootnote } from './stats-period-footnote';
import { useGetOrgActivityStats } from '../../../api/queries/analyticsQueries/useGetOrgActivityStats';
import { useLazyUserMetadata } from '../../../api/queries/useGetUserMetadata';
import { formatDateXAgo } from '../../../helpers/formatDate';

/** High-level activity stats for a single user, rendered inside a popover. */
export function UserStatsPopover({
  userId,
  email,
  organisationId,
  startDate,
  endDate,
}: {
  userId: string;
  email: string;
  organisationId: string;
  startDate?: Date;
  endDate?: Date;
}) {
  const userMetadata = useLazyUserMetadata();

  useEffect(() => {
    userMetadata.fetchMetadata([userId]);
  }, [userId]);

  const metadata = userMetadata.getMetadata(userId);
  const lastActive =
    metadata?.lastActiveAt !== undefined ? formatDateXAgo(new Date(metadata.lastActiveAt * 1000)) : null;

  const { data: stats } = useGetOrgActivityStats({
    data: { organisationId, userId, startDate, endDate },
  });

  return (
    <div>
      <div className="mb-2 border-b border-gray-100 pb-2">
        <p className="truncate text-sm font-medium text-gray-900">{email}</p>
        {lastActive && <p className="text-xs text-gray-400">Last active {lastActive}</p>}
      </div>

      <StatRow label="Pages" value={stats?.pages} />
      <StatRow label="Runs" value={stats?.runs} />
      <StatRow label="Matters" value={stats?.matters} />
      <StatRow label="Fact chronologies" value={stats?.chronologies} />
      <StatRow label="Doc chronologies" value={stats?.docChronologies} />
      <StatRow label="Kim threads" value={stats?.kimThreads} />

      <StatsPeriodFootnote startDate={startDate} endDate={endDate} />
    </div>
  );
}
